<template>
  <span>
    <b-button :href="url"
      v-if="type === 'button'"
    >
      Vai a cartella progetto
    </b-button>
    <b-link class="code" :href="url" v-if="type === 'link'">{{code}}</b-link>
  </span>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      validator: function (value) {
        return ['button', 'link'].includes(value)
      },
      default: 'link'
    },
    isFolderDef: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    code() {
      return this.project.code
    },
    projectYear() {
      return this.project.requestDate ? this.project.requestDate.slice(0, 4) : ''
    },
    url() {
      // encoded backslash because a regression bug in Chrome 130 (sett 2024)
      // bug should be corrected in Chrome 132 (dic 2024)
      // this workaround permits to show url and localExplorer to work correctly
      // NOTE: restored links to original format during a improvement task - 15/06/26
      const defSuffix = this.isFolderDef ? '\\def' : ''
      let basePath = '\\\\GRAFICA\\Disegni\\Disegni'
      if (this.projectYear >= 2004 && this.projectYear <= 2012) {
        basePath = '\\\\davide\\Davide\\DISEGNI'
      }
      // return `localexplorer:%5C%5CGRAFICA%5CDisegni%5CDisegni%5C${this.projectYear}%5C${this.code + defSuffix}`
      return `localexplorer:${basePath}\\${this.projectYear}\\${this.code + defSuffix}`
    }
  }
}
</script>
